// extracted by mini-css-extract-plugin
export default {"list":"list__CeFaC","listItem":"listItem__K5bwA","icon":"icon__ZbnmN","subtext":"subtext__VqH0C"};